import React from 'react';
import {
  TableCell,
  TableRow,
  Radio
} from '@material-ui/core';


const NextechDuplicatedCustomerRow = ({duplicatedCustomer, nextechCustomerId, setNextechCustomerId}) => {
  const usaDateFormat = new Date(duplicatedCustomer.birthday).toLocaleDateString('en-US');

  return (
    <TableRow>
      <TableCell>
        <Radio
          checked={nextechCustomerId == duplicatedCustomer.id}
          value={duplicatedCustomer.id}
          onChange={(event) => {
            setNextechCustomerId(event.target.value);
          }}
          color="default"
          name="castomers-data"
        />
      </TableCell>
      <TableCell>
        {duplicatedCustomer.ui_id}
      </TableCell>
      <TableCell>
        {duplicatedCustomer.first_name}
      </TableCell>
      <TableCell>
        {duplicatedCustomer.last_name}
      </TableCell>
      <TableCell>
        {duplicatedCustomer.email}
      </TableCell>
      <TableCell>
        {duplicatedCustomer.phone}
      </TableCell>
      <TableCell>
        {usaDateFormat}
      </TableCell>
    </TableRow>
  );
};

export default NextechDuplicatedCustomerRow;
